module.exports = __webpack_public_path__ + "images/google_6a83464.png";